import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SupportplannerComponent } from './supportplanner.component';

const routes: Routes = [ { path: '', component: SupportplannerComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupportPlannerRoutingModule { }
